export const EHISTACCION = Object.freeze({
  CREATE : 1,
  UPDATE : 2,
  DELETE : 3,
  GET : 4
})
export const EHISTSECCION = Object.freeze({
  PARTE_GENERAL : 1,
  PARTE_RUTA : 2,
  PARTE_AYUDAS : 3,
  PARTE_CERTIFICADOS : 4,
  PARTE_REVISIONES : 5,
  VISUALIZADOR : 6,
  VISUALIZADOR_RES : 7
})